import { Controller } from "@hotwired/stimulus";
import { Turbo } from "@hotwired/turbo-rails";

// File upload controller with drag-and-drop support (single or multiple files)
export default class extends Controller {
  static targets = ["input", "placeholder", "preview", "filename", "submitContainer", "dropzone", "form"];
  static values = {
    url: String
  };

  connect() {
    this.dragCounter = 0;
    this.selectedFiles = [];
  }

  browse(event) {
    event.preventDefault();
    this.inputTarget.click();
  }

  fileSelected(event) {
    const files = Array.from(event.target.files);
    if (files.length > 0) {
      this.selectedFiles = files;
      this.showFilePreview();
    }
  }

  showFilePreview() {
    this.placeholderTarget.classList.add("d-none");
    this.previewTarget.classList.remove("d-none");

    if (this.selectedFiles.length === 1) {
      this.filenameTarget.textContent = this.selectedFiles[0].name;
    } else {
      this.filenameTarget.textContent = `${this.selectedFiles.length} files selected`;
    }

    if (this.hasSubmitContainerTarget) {
      this.submitContainerTarget.style.display = "block";
    }
  }

  clear(event) {
    event.preventDefault();
    this.inputTarget.value = "";
    this.selectedFiles = [];
    this.placeholderTarget.classList.remove("d-none");
    this.previewTarget.classList.add("d-none");

    if (this.hasSubmitContainerTarget) {
      this.submitContainerTarget.style.display = "none";
    }
  }

  // Drag and drop handlers
  dragover(event) {
    event.preventDefault();
    event.stopPropagation();
  }

  dragenter(event) {
    event.preventDefault();
    event.stopPropagation();
    this.dragCounter++;

    if (this.hasDropzoneTarget) {
      this.dropzoneTarget.classList.add("dragover");
    }
  }

  dragleave(event) {
    event.preventDefault();
    event.stopPropagation();
    this.dragCounter--;

    if (this.dragCounter === 0 && this.hasDropzoneTarget) {
      this.dropzoneTarget.classList.remove("dragover");
    }
  }

  drop(event) {
    event.preventDefault();
    event.stopPropagation();
    this.dragCounter = 0;

    if (this.hasDropzoneTarget) {
      this.dropzoneTarget.classList.remove("dragover");
    }

    const files = Array.from(event.dataTransfer.files);
    if (files.length > 0) {
      this.selectedFiles = files;
      this.showFilePreview();
    }
  }

  async submit(event) {
    event.preventDefault();

    if (this.selectedFiles.length === 0) {
      return;
    }

    const formData = new FormData();
    this.selectedFiles.forEach((file) => {
      formData.append("files[]", file);
    });

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute("content");

    try {
      const response = await fetch(this.urlValue, {
        method: "POST",
        headers: {
          "X-CSRF-Token": csrfToken,
          "Accept": "text/vnd.turbo-stream.html"
        },
        body: formData
      });

      if (response.ok) {
        const html = await response.text();
        Turbo.renderStreamMessage(html);
      }
    } catch (error) {
      console.error("Upload failed:", error);
    }
  }
}
